/**
 * 内部リンクかどうかを判定
 * @param href - 判定対象のURL
 * @returns 内部リンク（"/"で始まる）の場合はtrue
 */
export const isInternalLink = (href: string | undefined): boolean => {
  if (!href) return false;
  // "//" で始まる場合は protocol-relative URL なので外部リンク
  if (href.startsWith("//")) return false;
  return href.startsWith("/");
};

/**
 * http / https の絶対URLかどうかを判定する。
 * API応答などから受け取ったURLを href に渡す前のスキーム許可リストとして使う
 * （javascript: や data: のURLをクリックで実行させないため）
 * @param href - 判定対象のURL
 * @returns http または https の絶対URLの場合はtrue
 */
export const isHttpUrl = (href: string | undefined): boolean => {
  if (!href) return false;
  try {
    const { protocol } = new URL(href);
    return protocol === "http:" || protocol === "https:";
  } catch {
    return false;
  }
};
